import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import {
  handleSuccessPurchase,
  setPending,
} from "@web-solutions/core/store/billing/actions";

import { PaymentSystem } from "..";

import type { SdkInstance } from "./truegate-sdk";

export const ApplePayTruegateContainer: React.FC<any> = ({
  options,
  email,
  product,
  onSubmit,
  onSuccess,
  onReady,
  onClick,
  onError,
}) => {

  const productId = product?.truegateId || product?.productCode || "no product";
  const intent =
    options?.orderDetails?.products?.[productId] ||
    options?.orderDetails?.one_time_products?.[productId] ||
    options?.orderDetails;

  const dispatch = useDispatch();

  useEffect(() => {
    const init = async () => {
      const ID = "APPLE_PAY_TRUEGATE";

      //@ts-ignore
      const sdkInstance: SdkInstance = new window.truegateSdk({
        id: ID,
        transactionId: intent.transactionId,
        env: process.env.REACT_APP_TRUEGATE_ENV as any,
      });

      sdkInstance.on("APPLE_PAY_READY" as any, (payload) => {
        onReady({
          paymentSystem: PaymentSystem.TRUEGATE,
        });
      });

      sdkInstance.on("APPLE_PAY_BUTTON_CLICK" as any, (payload) => {
        onClick({
          paymentSystem: PaymentSystem.TRUEGATE,
        });
      });

      sdkInstance.on("PAYMENT_STATUS" as any, (payload: any) => {
        if (
          payload.details.status === "FAILED" &&
          payload.channel === "APPLE_PAY"
        ) {
          dispatch(setPending(false));
          onError({
            paymentSystem: PaymentSystem.TRUEGATE,
            method: "applepay",
            amount: product.amount,
            currency: product.currency,
            email,
          });
          console.log("ERROR", payload);
          return;
        }
        if (
          payload.details.status === "PENDING" &&
          payload.channel === "APPLE_PAY"
        ) {
          dispatch(setPending(true));
          onSubmit({
            paymentSystem: PaymentSystem.TRUEGATE,
            method: "applepay",
            amount: product.amount,
            currency: product.currency,
            email,
            subscription_id: productId,
            transaction_id: intent.transactionId,
            price_id: productId,
          });
        }
        if (
          payload.details.status === "SUCCESS" &&
          payload.channel === "APPLE_PAY"
        ) {
          dispatch(
            handleSuccessPurchase({
              paymentSystem: PaymentSystem.TRUEGATE,
              email,
              method: "applepay",
              amount: product.amount,
              currency: product.currency,
              subscription_id: productId,
              transaction_id: intent.transactionId,
              price_id: productId,
            } as any)
          );
          onSuccess({
            paymentSystem: PaymentSystem.TRUEGATE,
            method: "applepay",
            amount: product.amount,
            email,
            currency: product.currency,
            subscription_id: productId,
            transaction_id: intent.transactionId,
            price_id: productId,
          });
          dispatch(setPending(false));
        }
      });

      await sdkInstance.init();
      await sdkInstance.initApplePay({
        id: `truegate-apple-pay-button-${intent.transactionId}`,
        buttonOptions: { HEIGHT: "52px" },
      });
    };

    if (intent) {
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intent]);

  if (!intent) {
    return null;
  }

  return (
    <div
      key={`truegate-apple-pay-button-${intent.transactionId}`}
      id={`truegate-apple-pay-button-${intent.transactionId}`}
      style={{ width: "100%", height: "52px", border: "none" }}
    />
  );
};
